import {Box} from 'exsportia-components'
import React, {FC} from 'react'

import {useInvoiceDownloadDoc} from '../../../api/invoice/hooks'
import {CycleToShow} from '../../../api/subscription-bookings/helpers'
import {SubscriptionBooking, SubscriptionBookingStatusesEnum} from '../../../api/subscription-bookings/types'
import {useVenue} from '../../../api/venue/hooks'
import {AdditionalFeeRow} from './additional-fee-invoice'
import {PaidInvoice} from './paid-invoice'
import {UnpaidInvoice} from './unpaid-invoice'

type Props = {
  cycles: CycleToShow[]
  rolling: boolean
  subStatus: SubscriptionBooking['subStatus']
  cyclesLength: number,
  additionalFee: SubscriptionBooking['additionalFee']
  isPaidAdditionalFee: SubscriptionBooking['isPaidAdditionalFee']
}

export const InvoicesList: FC<Props> = ({
  cycles,
  rolling,
  subStatus,
  cyclesLength,
  additionalFee,
  isPaidAdditionalFee,
}) => {
  const downloadAccountingDoc = useInvoiceDownloadDoc()
  const {data: venue} = useVenue()
  if (!venue) {
    return null
  }

  return (
    <Box>
      {
        additionalFee
        && (
          <AdditionalFeeRow
            openInvoicePdf={downloadAccountingDoc}
            additionalFee={additionalFee}
            currency={venue.currency}
            isPaidAdditionalFee={isPaidAdditionalFee}
            // eslint-disable-next-line
            transaction={cycles[0]?.transactions?.[0]}
          />
        )
      }
      {
        cycles.map((el, i) => {
          const cycleVariant = el.isPaid
            ? 'PAID'
            : 'UNPAID'
          if (cycleVariant === 'PAID') {
            return (
              <Box key={i}>
                <PaidInvoice
                  openInvoicePdf={downloadAccountingDoc}
                  rolling={rolling}
                  cyclesLength={cyclesLength}
                  currency={venue.currency}
                  cycle={el}
                />
              </Box>
            )
          }

          if (
            subStatus !== SubscriptionBookingStatusesEnum.AWAITING_PAYMENT
            && subStatus !== SubscriptionBookingStatusesEnum.PAYMENT_FAILED
          ) {
            return null
          }

          return (
            <Box key={i}>
              <UnpaidInvoice
                subStatus={subStatus}
                rolling={rolling}
                cyclesLength={cyclesLength}
                currency={venue.currency}
                cycle={el}
              />
            </Box>
          )
        })
      }
    </Box>
  )
}